import React from "react";
import { Link } from "react-router-dom";
import { Footer } from "@/components/landing/Footer";
import { WaveIcon } from "@/components/landing/Decorations";

export default function PrivacyPage() {
    return (
        <div className="min-h-screen bg-cream-100 text-ink">
            <header className="border-b border-cream-300 bg-white/80 backdrop-blur">
                <div className="mx-auto max-w-[1080px] px-5 sm:px-8 py-4 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2.5">
                        <WaveIcon color="#FF5B3E" className="w-6 h-4"/>
                        <span className="font-display text-[22px] font-semibold tracking-tight">Audo</span>
                    </Link>
                    <Link to="/" className="text-[13px] text-ink-muted hover:text-coral transition-colors">Back to home</Link>
                </div>
            </header>

            <main className="mx-auto max-w-[900px] px-5 sm:px-8 py-10 sm:py-14">
                <p className="text-[11px] uppercase tracking-[0.2em] font-semibold text-coral mb-2">Legal</p>
                <h1 className="font-display text-[40px] sm:text-[52px] leading-[1.05] font-semibold tracking-tight mb-4">Privacy Policy</h1>
                <p className="text-[14px] text-ink-muted mb-8">Last updated: April 27, 2026</p>

                <div className="bg-white border border-cream-300 rounded-3xl p-6 sm:p-8 space-y-6 text-[14px] leading-relaxed">
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">1. What we collect</h2>
                        <p>We collect account data (name, email, password hash), workspace data (articles, generated audio metadata, analytics), billing records, and support messages you submit to Audo.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">2. How we use data</h2>
                        <p>We use data to provide text-to-audio services, manage your account, process subscriptions and top-ups, deliver support, and improve product reliability and quality.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">3. Sharing</h2>
                        <p>We share data only with required service providers (such as payment and infrastructure vendors) to operate Audo. We do not sell personal data.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">4. Retention</h2>
                        <p>We retain account, billing, and service records as needed for operations, legal compliance, and security. You may request account deletion through support.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">5. Security</h2>
                        <p>We use access controls, token-based authentication, and industry-standard security practices. No platform can guarantee absolute security, but we continuously improve safeguards.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">6. Your rights</h2>
                        <p>You can request correction or deletion of personal data by emailing <a href="mailto:contact@audo.dev" className="text-coral hover:underline">contact@audo.dev</a>.</p>
                    </section>
                </div>
            </main>

            <Footer/>
        </div>
    );
}
